export function sanitizeAndValidateRegex(str = '', regex) {
  return regex.test(str.trim());
}

export function hasTwoOrMoreCharsOnFirstWord(str) {
  return sanitizeAndValidateRegex(str, /^[a-zA-ZÀ-ü '-]{2,}[a-zA-ZÀ-ü '-]*$/);
}

export function optionalHasTwoOrMoreCharsOnFirstWord(str) {
  return sanitizeAndValidateRegex(str, /(^[a-zA-ZÀ-ü '-]{2,}[a-zA-ZÀ-ü '-]*$)|(^$)/);
}

export function hasOneOrMoreChars(str) {
  return sanitizeAndValidateRegex(str, /^.+$/);
}

export function hasEightOrMoreChars(str) {
  return sanitizeAndValidateRegex(str, /^.{7}.+$/);
}

export function hasFiveNumericalChars(str) {
  return sanitizeAndValidateRegex(str, /^\d{5}$/);
}

export function hasFourNumericalChars(str) {
  return sanitizeAndValidateRegex(str, /^\d{4}$/);
}

export function hasJustAlphaNumericalCharsWithSpacesAndDots(str) {
  // eslint-disable-next-line no-useless-escape
  return sanitizeAndValidateRegex(str, /^[0-9a-zA-ZÀ-ü \.]+$/);
}

const daysInYear = 365.25;
const oneHundredAndFiftyYearsInDays = 150 * daysInYear;
const tenYearsInDays = 10 * daysInYear;

export function dobYearValidation(dateStr) {
  const [day, month, year] = dateStr.split('/');
  const chosenDate = new Date(year, month - 1, day);

  const today = new Date();
  const startDate = new Date().setDate(today.getDate() - oneHundredAndFiftyYearsInDays);
  const endDate = new Date().setDate(today.getDate() - tenYearsInDays);

  return chosenDate >= startDate && chosenDate <= endDate;
}
